module.exports = __webpack_public_path__ + "static/media/sbahn-o-echtzeit~txWfGUFK.d4a9c05a.svg";